import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import App from '@/App';
import ReposActions from '@/store/ducks/repos';
import SkillsActions from '@/store/ducks/skills';
import ExperienceActions from '@/store/ducks/experience';
import AcademicActions from '@/store/ducks/academic';

const mapStateToProps = ({ loaderReducer, reposReducer, skillsReducer, experienceReducer, academicReducer }) => {
  const { primaryLoader } = loaderReducer || {};
  const { reposError } = reposReducer || {};
  const { skillsError } = skillsReducer || {};
  const { experienceError } = experienceReducer || {};
  const { academicError } = academicReducer || {};
  return { primaryLoader, reposError, skillsError, experienceError, academicError };
};

const mapDispatchToProps = (dispatch) => {
  const { getReposRequest } = ReposActions;
  const { getSkillsRequest } = SkillsActions;
  const { getExperienceRequest } = ExperienceActions;
  const { getAcademicRequest } = AcademicActions;
  return bindActionCreators({ getReposRequest, getSkillsRequest, getAcademicRequest, getExperienceRequest }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
